import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as settings from "../../constants/settings";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.PRICING_SET_GENERIC_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_GENERIC_DATA
                    },
                    method: handlers.PRICING_GET_GENERIC_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];
        case handlers.PRICING_GET_GENERIC_DATA:
            if (!responseHelper.isPricingGetDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRICING_GENERIC_DATA,
                    payload: {
                        genericData: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_GENERIC_COLORANT_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_GENERIC_COLORANT_DATA
                    },
                    method: handlers.PRICING_GET_GENERIC_COLORANT_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];
        case handlers.PRICING_GET_GENERIC_COLORANT_DATA:
            if (!responseHelper.isPricingGetDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRICING_GENERIC_COLORANT_DATA,
                    payload: {
                        genericColorantData: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_GENERIC_PRODUCT_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_GENERIC_PRODUCT_DATA
                    },
                    method: handlers.PRICING_GET_GENERIC_PRODUCT_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];
        case handlers.PRICING_GET_GENERIC_PRODUCT_DATA:
            if (!responseHelper.isPricingGetDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRICING_GENERIC_PRODUCT_DATA,
                    payload: {
                        genericProductData: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_GENERIC_PACKAGE_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_GENERIC_PACKAGE_DATA
                    },
                    method: handlers.PRICING_GET_GENERIC_PACKAGE_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];
        case handlers.PRICING_GET_GENERIC_PACKAGE_DATA:
            if (!responseHelper.isPricingGetDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRICING_GENERIC_PACKAGE_DATA,
                    payload: {
                        genericPackageData: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_COLORANT_DATA:
        case handlers.PRICING_SET_COLORANT_MARGIN_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_COLORANTS_DATA
                    },
                    method: handlers.PRICING_GET_COLORANTS_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];
        case handlers.PRICING_GET_COLORANTS_DATA:
            if (!responseHelper.isPricingGetDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRICING_COLORANT_DATA,
                    payload: {
                        colorantData: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_BASE_IN_PRODUCT_DATA:
        case handlers.PRICING_SET_BASE_IN_PRODUCT_MARGIN_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (state.pricing.activeProduct === null) {
                return [
                    {
                        type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_BASE_IN_PRODUCTS_DATA,
                        params: {
                            productId: state.pricing.activeProduct.id
                        }
                    },
                    method: handlers.PRICING_GET_BASE_IN_PRODUCTS_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA,
                        params: {
                            productId: state.pricing.activeProduct.id
                        }
                    },
                    method: handlers.PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];
        case handlers.PRICING_GET_BASE_IN_PRODUCTS_DATA:
            if (!responseHelper.isPricingGetDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRICING_BASE_IN_PRODUCTS_DATA,
                    payload: {
                        baseInProductsData: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_BASE_IN_PRODUCT_PACKAGE_DATA:
        case handlers.PRICING_SET_BASE_IN_PRODUCT_PACKAGE_MARGIN_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (state.pricing.activeProduct === null) {
                return [
                    {
                        type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA,
                        params: {
                            productId: state.pricing.activeProduct.id
                        }
                    },
                    method: handlers.PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];
        case handlers.PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA:
            if (!responseHelper.isPricingGetDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRICING_PRODUCT_DATA,
                    payload: {
                        baseInProductPackagesData: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_PACKAGE_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_PACKAGES_DATA
                    },
                    method: handlers.PRICING_GET_PACKAGES_DATA,
                    tabId: 0
                }
            ];
        case handlers.PRICING_GET_PACKAGES_DATA:
            if (!responseHelper.isPricingGetDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRICING_PACKAGE_DATA,
                    payload: {
                        packageData: response.data
                    }
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];
        case handlers.PRICING_SET_PRICE_DEFINITION:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRICE_SETTING,
                        params: {
                            key: settings.PRICING_PRICE_DEFINITION
                        }
                    },
                    method: handlers.PRICING_GET_PRICE_DEFINITION,
                    tabId: 0
                }
            ];
        case handlers.PRICING_GET_PRICE_DEFINITION:
            if (!responseHelper.isGetPriceSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.PRICE_SETTINGS_SAVE_PRICE_DEFINITION,
                    payload: {
                        priceDefinition: response.data
                    }
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];
        case handlers.PRICING_SET_PRICE_UNIT_DEFINITION:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRICE_SETTING,
                        params: {
                            key: settings.PRICING_PRICE_UNIT_DEFINITION
                        }
                    },
                    method: handlers.PRICING_GET_PRICE_UNIT_DEFINITION,
                    tabId: 0
                }
            ];
        case handlers.PRICING_GET_PRICE_UNIT_DEFINITION:
            if (!responseHelper.isGetPriceSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.PRICE_SETTINGS_SAVE_PRICE_UNIT_DEFINITION,
                    payload: {
                        priceUnitDefinition: response.data
                    }
                },
                {
                    type: actionTypes.RELOAD_PRICE_SETTINGS_DATA
                }
            ];
        case handlers.PRICING_SET_PRICE_GROUP_NUMBER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRICE_SETTING,
                        params: {
                            key: settings.PRICING_NUMBER_PRICE_GROUPS
                        }
                    },
                    method: handlers.PRICING_GET_PRICE_GROUP_NUMBER,
                    tabId: 0
                }
            ];
        case handlers.PRICING_GET_PRICE_GROUP_NUMBER:
            if (!responseHelper.isGetPriceSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.PRICE_SETTINGS_SAVE_PRICE_GROUP_NUMBER,
                    payload: {
                        priceGroupNumber: response.data
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_GENERIC_DATA
                    },
                    method: handlers.PRICING_GET_GENERIC_DATA,
                    tabId: 0
                }
            ];
        case handlers.PRICING_SET_PRICE_GROUPS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRICE_SETTING,
                        params: {
                            key: settings.PRICING_PRICE_GROUPS_ENABLED
                        }
                    },
                    method: handlers.PRICING_GET_PRICE_GROUPS,
                    tabId: 0
                }
            ];
        case handlers.PRICING_GET_PRICE_GROUPS:
            if (!responseHelper.isGetPriceSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.PRICE_SETTINGS_SAVE_PRICE_GROUPS,
                    payload: {
                        priceGroupsEnabled: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_SETTING_LOCAL_PRICES:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRICE_SETTING,
                        params: {
                            key: settings.PRICING_LOCAL_PRICES
                        }
                    },
                    method: handlers.PRICING_GET_SETTING_LOCAL_PRICES,
                    tabId: 0
                }
            ];
        case handlers.PRICING_GET_SETTING_LOCAL_PRICES:
            if (!responseHelper.isGetPriceSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.PRICE_SETTINGS_SAVE_LOCAL_PRICES,
                    payload: {
                        showLocalPrices: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_SETTING_MARGIN:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRICE_SETTING,
                        params: {
                            key: settings.PRICING_USE_MARGIN
                        }
                    },
                    method: handlers.PRICING_GET_SETTING_MARGIN,
                    tabId: 0
                }
            ];
        case handlers.PRICING_GET_SETTING_MARGIN:
            if (!responseHelper.isGetPriceSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.PRICE_SETTINGS_SAVE_MARGIN,
                    payload: {
                        showMargin: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_SETTING_MARKUP:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRICE_SETTING,
                        params: {
                            key: settings.PRICING_USE_MARKUP
                        }
                    },
                    method: handlers.PRICING_GET_SETTING_MARKUP,
                    tabId: 0
                }
            ];
        case handlers.PRICING_GET_SETTING_MARKUP:
            if (!responseHelper.isGetPriceSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.PRICE_SETTINGS_SAVE_MARKUP,
                    payload: {
                        showMarkup: response.data
                    }
                }
            ];
        case handlers.PRICING_SET_SETTING_DISCOUNT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRICE_SETTING,
                        params: {
                            key: settings.PRICING_USE_DISCOUNT
                        }
                    },
                    method: handlers.PRICING_GET_SETTING_DISCOUNT,
                    tabId: 0
                }
            ];
        case handlers.PRICING_GET_SETTING_DISCOUNT:
            if (!responseHelper.isGetPriceSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.PRICE_SETTINGS_SAVE_DISCOUNT,
                    payload: {
                        showDiscount: response.data
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
